

export const frontMatter = {};
export const contentTitle = 'Collections';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-guides-collections-mdx-4d0.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Rendering optimization caveat",
  "id": "rendering-optimization-caveat",
  "level": 2
}, {
  "value": "Using context",
  "id": "using-context",
  "level": 3
}, {
  "value": "Wrapping items with extra state",
  "id": "wrapping-items-with-extra-state",
  "level": 3
}, {
  "value": "Disabling or limiting cache",
  "id": "disabling-or-limiting-cache",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "collections",
        children: "Collections"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["A good number of components such as List, Tree, Menu, Tabs, etc. display a collection of items.\n", _jsx(_components.a, {
        href: "https://react-spectrum.adobe.com/react-stately/collections.html",
        children: "@react-stately/collections"
      }), " is used for all of them\nto provide a uniform and flexible API that would allow for both static jsx-based or dynamic source of items."]
    }), "\n", _jsx(_components.h2, {
      id: "rendering-optimization-caveat",
      children: "Rendering optimization caveat"
    }), "\n", _jsxs(_components.p, {
      children: ["When the API for dynamic items (", _jsx(_components.code, {
        children: "items"
      }), " prop and a render function as ", _jsx(_components.code, {
        children: "children"
      }), ") is used, the render result for each\nitem ", _jsx(_components.a, {
        href: "https://react-spectrum.adobe.com/react-stately/collections.html#why-not-array-map",
        children: "is subject to caching"
      }), " based\non the item object. It's important to understand this assumption that the rendering should only depend on the item, and\nnot any other piece of state, for example, from the closure."]
    }), "\n", _jsx(_components.admonition, {
      type: "info",
      children: _jsx(_components.p, {
        children: "The item renderer function should be a pure function that relies exclusively on its single argument: the item object."
      })
    }), "\n", _jsx(_components.p, {
      children: "However, in certain scenarios, you might need to render UI elements based on factors other than the item object. Here are a few ways to achieve this:"
    }), "\n", _jsx(_components.h3, {
      id: "using-context",
      children: "Using context"
    }), "\n", _jsx(_components.p, {
      children: "TODO (This is particularly useful for components implementing virtual rendering, where only a limited number of items are mounted at a time, and changes to additional state should affect only those without rebuilding the entire collection)."
    }), "\n", _jsx(_components.h3, {
      id: "wrapping-items-with-extra-state",
      children: "Wrapping items with extra state"
    }), "\n", _jsx(_components.p, {
      children: "TODO"
    }), "\n", _jsx(_components.h3, {
      id: "disabling-or-limiting-cache",
      children: "Disabling or limiting cache"
    }), "\n", _jsxs(_components.p, {
      children: ["For components that support it, you can control caching by setting the ", _jsx(_components.code, {
        children: "cacheInvalidation"
      }), " prop. Passing ", _jsx(_components.code, {
        children: "true"
      }), " to this prop will disable caching entirely, but it may significantly reduce performance for large collections. In a performance test on a ", _jsx(_components.a, {
        href: "../components/Tree",
        children: "Tree"
      }), " with 400 elements, disabling the cache resulted in a ~10x slower rendering."]
    }), "\n", _jsx(_components.p, {
      children: "A middle-ground approach is to pass an array of cache invalidators instead of completely turning off the cache:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<Tree cacheInvalidation={{ invalidators: [nestedSelection] }}>...</Tree>\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["This configuration will only invalidate the cache when ", _jsx(_components.code, {
        children: "nestedSelection"
      }), " changes."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

